// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__BSznH","title":"Info_title__1sfbQ","selects":"Info_selects__3QCdg","requiredAsterisk":"Info_requiredAsterisk__2xi5B"};